import * as React from 'react';
import { IconProps } from '../types';

const IcMarketing = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill={props?.fill ?? '#232F3E'}
        d="M21.499 3.15A1.875 1.875 0 0 0 19.744 3l-9.255 3.645a1.83 1.83 0 0 1-.69.135H3.874a1.875 1.875 0 0 0-1.875 1.875v.15H.124v4.5h1.875v.195a1.875 1.875 0 0 0 1.875 1.83l2.25 4.77a1.89 1.89 0 0 0 1.695 1.08h.945a1.875 1.875 0 0 0 1.86-1.875V15.51l9.12 3.645c.224.09.464.135.705.135.375-.006.74-.12 1.05-.33a1.875 1.875 0 0 0 .825-1.5V4.695a1.874 1.874 0 0 0-.825-1.545ZM8.749 8.655V13.5H3.874V8.655h4.875Zm0 10.65h-.945L5.959 15.33h2.79v3.975Zm2.43-5.58a3.436 3.436 0 0 0-.555-.225V8.55c.19-.039.375-.094.555-.165l9.27-3.69v12.72l-9.27-3.69Zm11.19-4.545v3.75a1.875 1.875 0 0 0 0-3.75Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.124 0h24v24h-24z" />
      </clipPath>
    </defs>
  </svg>
);

export default IcMarketing;
